import { render, staticRenderFns } from "./CImage.vue?vue&type=template&id=0a7d2c62&scoped=true"
import script from "./CImage.vue?vue&type=script&lang=ts"
export * from "./CImage.vue?vue&type=script&lang=ts"
import style0 from "./CImage.vue?vue&type=style&index=0&id=0a7d2c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d2c62",
  null
  
)

export default component.exports